import React from "react";
import { useCountdown } from "../hooks/useOffer";
type CountdownProps = {
  tone?: "light" | "dark";
  label?: string;
};
export function Countdown({
  tone = "dark",
  label = "The special offer ends in:"
}: CountdownProps) {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  const units = [{
    value: hours,
    unit: "Hours"
  }, {
    value: minutes,
    unit: "Minutes"
  }, {
    value: seconds,
    unit: "Seconds"
  }];
  const dark = tone === "dark";
  return <div className="mx-auto w-full max-w-xl text-center" role="timer" aria-label={label} data-id="element-125" data-mp="3c48qcjilh3gx">
      <p className={`font-display text-lg font-semibold uppercase tracking-wide ${dark ? "text-white" : "text-ink"}`} data-id="element-126" data-mp="3gyw901qx33nl">
        {label}
      </p>
      <div className="mt-3 flex items-start justify-center gap-2 sm:gap-3" data-id="element-127" data-mp="371zw7jtzjvd8">
        {units.map((u, i) => <React.Fragment key={u.unit} data-id="element-128" data-mp="10dellto23bwt" data-mpi={i}>
            <div className="flex flex-col items-center" data-id="element-129" data-mp="10a8ru14hflur">
              <span className="flex h-[72px] w-[78px] items-center justify-center rounded-xl bg-alert font-display text-[2.6rem] font-bold tabular-nums leading-none text-white sm:h-20 sm:w-24 sm:text-5xl" data-id="element-130" data-mp="15add04gc54rb">
                {String(u.value).padStart(2, "0")}
              </span>
              <span className={`mt-1.5 text-xs font-semibold uppercase tracking-wider ${dark ? "text-white/70" : "text-ink-soft"}`} data-id="element-131" data-mp="17rhnota0o8w0">
                {u.unit}
              </span>
            </div>
            {i < units.length - 1 && <span className={`pt-3 font-display text-4xl font-bold ${dark ? "text-white" : "text-ink"}`} aria-hidden="true" data-id="element-132" data-mp="f2ua7jvient0">
                :
              </span>}
          </React.Fragment>)}
      </div>
    </div>;
}